<template>
    <span>
        <i class="fas fa-spinner fa-spin" :class="`m-${margin}`"></i>
    </span>
</template>

<script>
export default {
    props: {
        margin: {
            type: Number,
            default: 1
        }
    }
};
</script>
